import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DialogDataEnum } from '../../../enums/dialog.enum';
import { DialogFocusDirective } from '../../../a11y/dialog-focus.directive';

/**
 * Cancel-policy note passed in by the opener (#836). No new API call — the caller
 * derives within/outside the cancellation window client-side and hands the copy
 * + the boolean in via MAT_DIALOG_DATA. Optional so existing openers that do not
 * supply data keep the default credit message.
 */
export interface BookingCancelDialogDataI {
  policyMessage: string;
  withinCutoff: boolean;
}

@Component({
  imports: [MatDialogModule, DialogFocusDirective],
  selector: 'bodyanalytics-booking-cancel-dialog',
  templateUrl: './booking-cancel-dialog.component.html',
  styleUrls: ['./booking-cancel-dialog.component.scss'],
})
export class BookingCancelDialogComponent {
  data = inject<BookingCancelDialogDataI | null>(MAT_DIALOG_DATA, { optional: true });

  protected dialogEnum = DialogDataEnum;

  /** Cancel-policy line for this booking, or the default credit message when none supplied. */
  public get policyMessage(): string {
    return this.data?.policyMessage ?? 'You will receive account credit for this booking.';
  }
}
